import { SovosBox } from "mosaic-react";
import React from "react";
import EmptyMappingContexts from "../EmptyMappingContexts";
import InlineLoadError from "../InlineLoadError";
import ChooseEntityPageSection from "./ChooseEntityPageSection";
import CountryAutocompleteField from "./CountryAutocompleteField";
import LegalStructureField from "./LegalStructureField";

const LegalStructureSection = ({
    contextError,
    contexts,
    countryCode,
    hasNoContexts,
    i18n,
    legalStructureId,
    loadingContexts,
    onLoadContexts,
    onSelectCountry,
    onSelectStructure,
    structures,
}) => (
    <ChooseEntityPageSection
        description={i18n`Select the country and SAF-T legal structure that applies to your data.`}
        title={i18n`Legal structure`}
    >
        <SovosBox
            sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: 128,
                width: "100%",
            }}
        >
            <CountryAutocompleteField
                contexts={contexts}
                disabled={loadingContexts || contextError || hasNoContexts}
                i18n={i18n}
                loading={loadingContexts}
                onChange={onSelectCountry}
                value={countryCode}
            />
            {contextError && <InlineLoadError i18n={i18n} onRetry={onLoadContexts} />}
            {hasNoContexts && <EmptyMappingContexts i18n={i18n} onRetry={onLoadContexts} />}

            <LegalStructureField
                disabled={!countryCode || structures.length <= 1}
                i18n={i18n}
                onChange={onSelectStructure}
                structures={structures}
                value={legalStructureId}
            />
        </SovosBox>
    </ChooseEntityPageSection>
);

export default LegalStructureSection;
